import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  DateInput,
  SelectInput,
  ReferenceInput,
  required,
} from 'react-admin';
import { Grid } from '@mui/material';

const statusChoices = [
  { id: 'active', name: 'Active' },
  { id: 'expired', name: 'Expired' },
  { id: 'suspended', name: 'Suspended' },
  { id: 'revoked', name: 'Revoked' },
];

export const DriverLicenseEdit = () => (
  <Edit>
    <SimpleForm>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="driverId" reference="drivers">
            <SelectInput optionText={(record: any) => record?.user?.name ? `${record.user.name} (Driver ID: ${record.id})` : `Driver ID: ${record?.id}`} validate={required()} fullWidth />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <ReferenceInput source="licenseTypeId" reference="license-types">
            <SelectInput optionText={(record: any) => `${record?.name} - ${record?.province}`} validate={required()} />
          </ReferenceInput>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextInput source="code" fullWidth />
        </Grid>
        <Grid item xs={12} md={6}>
          <DateInput source="expiry" fullWidth />
        </Grid>
        <Grid item xs={12}>
          <SelectInput 
            source="status" 
            choices={statusChoices}
            fullWidth
          />
        </Grid>
      </Grid>
    </SimpleForm>
  </Edit>
);